// heatmap.js 2.0.5 reassigns ImageData.data (build/heatmap.js:527), which throws in strict mode
// (Vite ESM) because each ImageData instance's `data` is an own, non-writable property. Redefine it as
// writable on every getImageData result so the reassignment succeeds. Safe: data is still mutated in place.
(() => {
  if (typeof CanvasRenderingContext2D === "undefined") return;
  const proto = CanvasRenderingContext2D.prototype;
  if (proto.__heatmapDataWritablePatch) return;
  const orig = proto.getImageData;
  proto.getImageData = function (...args) {
    const img = orig.apply(this, args);
    try {
      Object.defineProperty(img, "data", { value: img.data, writable: true, configurable: true });
    } catch (e) {}
    return img;
  };
  proto.__heatmapDataWritablePatch = true;
})();
